import React from "react";
import { MdDirectionsBus } from "react-icons/md";

const ProcessInvoice = () => {
  return (
    <div className="p-[20px]">
      <div className="w-[60%] mx-auto">
        <form action="" className="">
          <div className="mb-[20px] border border-[#ddd] rounded-[3px] bg-white">
            <div className="p-[20px]">
              <h5 className="my-[2px] text-[17px]">
                Supplier Invoice Transaction{" "}
              </h5>
            </div>
            <div className="p-[20px] pt-0">
              <div className="flex items-center gap-2 mb-[20px] pb-[10px] uppercase border-b border-[#e5e5e5]">
                <MdDirectionsBus className="text-[12px]" />
                <label htmlFor="item" className="text-[12px] font-[500]">
                  Sales details
                </label>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Supplier:
                  </label>
                  <select
                    name=""
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  >
                    <option value=""></option>
                    <option value="Ernest Chemist">Ernest Chemist</option>
                  </select>
                </div>
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Date:
                  </label>
                  <input
                    type="date"
                    name=""
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Narration:
                  </label>
                  <input
                    type="text"
                    name=""
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Cheque Date:
                  </label>
                  <input
                    type="date"
                    name=""
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Amount:
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    name=""
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>

                <div className="flex flex-col mb-[20px]">
                  <label htmlFor="" className="font-bold">
                    Invoice Number:
                  </label>
                  <input
                    type="text"
                    name=""
                    id=""
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  />
                </div>
              </div>
              <div className="flex justify-end">
                <button className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                  Post Invoice
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProcessInvoice;
